export const defaultProviderResponse =
  'Approved for refill. Same dosage as previous. Can send to pharmacy directly.';

export const recommendationOptions = [
  {
    label: 'Medication',
    value: 'Medication'
  },
  {
    label: 'Continue Current Plan',
    value: 'Continue Current Plan'
  }
];

export const providerResponseFallback = {
  patient: 'Willow, Gwen Marry',
  mrNumber: '2318634',
  category: 'Medication',
  priority: 'Routine',
  issueNote:
    'Patient requesting refill for hypertension medication. Current prescription expires today.'
};